import { apiClient } from "helpers/api_helper";

export const getAllUsers = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/User/GetAllUsers`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getUserById = async (id: any) => {
    try {
        const response = await apiClient.get(`/api/v1/User/get?id=${id}`);
        return response;
        
    } catch (error: any) {
        throw new Error(error);
    }
};

export const createUser = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/User/Insert', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const updateUser = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/User/Update', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const deleteUser = async (id: any) => {
    try {
        const response = await apiClient.delete(`/api/v1/User/Delete?id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getUserPermissionById = async (id: any) => {
    try {
        const response = await apiClient.get(`/api/v1/User/GetPermissions?userId=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const updateUserPermission = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/User/UpsertPermissions', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};
